import { render, staticRenderFns } from "./CoursePayment.vue?vue&type=template&id=6dfbdf40&scoped=true"
import script from "./CoursePayment.vue?vue&type=script&lang=js"
export * from "./CoursePayment.vue?vue&type=script&lang=js"
import style0 from "./CoursePayment.vue?vue&type=style&index=0&id=6dfbdf40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfbdf40",
  null
  
)

export default component.exports